import { useMemo, useRef } from "react";
import { useIntl } from "react-intl";
import { MediaType } from "@/model";
import Button from "@/component/Button";
import FileInput from "@/component/input/FileInput";


interface ParagraphFileInputProps {
    disabled?: boolean;
    extensionType?: MediaType | "document";
    onLoad: (file: File, url: string, img: HTMLImageElement) => void;
    onError: (file: File, url: string) => void;
}

const ParagraphFileInput: React.FC<ParagraphFileInputProps> = (props) => {
    const { disabled, onLoad, extensionType, onError } = props;

    const intl = useIntl();

    const fileRef = useRef<HTMLInputElement>(null);

    const onClickAttachment = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        fileRef.current?.click();
    };

    const onChangeFile = (files: File[]) => {
        const file = files[0];
        if (!file) {
            return;
        }
        const url = URL.createObjectURL(file);

        const img = new window.Image();
        img.addEventListener("load", () => {
            onLoad(file, url, img);
        });

        img.addEventListener("error", () => {
            onError(file, url);
        });

        img.src = url;
    };

    const accept = useMemo(() => {
        switch (extensionType) {
            case "image":
            case "image_square":
                return ".jpg,.jpeg,.png,.gif";
            case "video":
                return ".mp4,.mpeg,.mov,.avi,.wmv";
            case "audio":
                return ".mp3,.wav,.ogg,.m4a";
            case "document":
                return ".doc,.docx,.hwp,.hwpml,.hwpx,.pdf,.ppt,.pptx,.msg,.eml,.md,.odt,.xls,.xlsx,.csv,.txt";
        }
    }, [extensionType]);

    return (
        <div className="flex-none flex items-center gap-2">
            <Button size="sm"
                    variant="primary"
                    disabled={disabled}
                    onClick={onClickAttachment}
            >
                {intl.formatMessage({ id: "b0004" })}
            </Button>
            <FileInput ref={fileRef}
                       accept={accept}
                       disabled={disabled}
                       onUpload={onChangeFile}
            />
        </div>
    );
};

export default ParagraphFileInput;
